import { Col, Row } from "antd";
import { get, set } from "lodash";
import { useTranslation } from "react-i18next";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const MarketingConsents = ({ setPercent, initialValues, bindField }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  const DIGITAL_OPTION = t("SUBSCRIPTION.FORM.DIGITAL_OPTION.MUTUAL_MOBILITY", {
    returnObjects: true,
  });

  const emailOffersPath = "project.contact.fields.acceptEmailOffers";
  const emailOffersField = bindField(emailOffersPath, {
    label: DIGITAL_OPTION.EMAIL_OFFERS_OPT_IN,
    onChange: () => setPercent(initialValues),
  });

  const smsOffersPath = "project.contact.fields.acceptSMSOffers";
  const smsOffersField = bindField(smsOffersPath, {
    label: DIGITAL_OPTION.SMS_OFFERS_OPT_IN,
    onChange: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.MARKETING_CONSENTS}-section`}
    >
      <Form
        type="vertical"
        title={
          SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.MARKETING_CONSENTS.TITLE
        }
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <FormField
              path={emailOffersField.path}
              label={emailOffersField.label}
              required={emailOffersField.required}
              disabled={emailOffersField.disabled}
            >
              {(field) => (
                <Input
                  type="switch"
                  label={emailOffersField.label}
                  defaultChecked={get(initialValues, emailOffersPath)}
                  {...field}
                  onChange={emailOffersField.onChange}
                />
              )}
            </FormField>
          </Col>
          <Col lg={24} xs={24}>
            <FormField
              path={smsOffersField.path}
              label={smsOffersField.label}
              required={smsOffersField.required}
              disabled={smsOffersField.disabled}
            >
              {(field) => (
                <Input
                  type="switch"
                  label={smsOffersField.label}
                  defaultChecked={get(initialValues, smsOffersPath)}
                  {...field}
                  onChange={smsOffersField.onChange}
                />
              )}
            </FormField>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default MarketingConsents;
